import {
  useQuery
} from '@tanstack/vue-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query'
import {
  unref
} from 'vue'
import type {
  MaybeRef
} from 'vue'
import type {
  ApiGetOrderBySaleIdParams,
  BackendErrorEntity,
  GetOrderResponseDto
} from '.././types'
import { fetchApiInstance } from '../../fetchApiInstance';
import type { ErrorType } from '../../fetchApiInstance';


type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];


export const apiGetOrderBySaleId = (
    params?: MaybeRef<ApiGetOrderBySaleIdParams>,
 options?: SecondParameter<typeof fetchApiInstance>,) => {
      params = unref(params);
      
      return fetchApiInstance<GetOrderResponseDto>(
      {url: `/my-order`, method: 'GET',
        params: unref(params)
    },
      options);
    }
  

export const getApiGetOrderBySaleIdQueryKey = (params?: MaybeRef<ApiGetOrderBySaleIdParams>,) => {
    return ['my-order', ...(params ? [params]: [])] as const;
    }

    
export const getApiGetOrderBySaleIdQueryOptions = <TData = Awaited<ReturnType<typeof apiGetOrderBySaleId>>, TError = ErrorType<BackendErrorEntity>>(params?: MaybeRef<ApiGetOrderBySaleIdParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetOrderBySaleId>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  getApiGetOrderBySaleIdQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiGetOrderBySaleId>>> = () => apiGetOrderBySaleId(params, requestOptions);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiGetOrderBySaleId>>, TError, TData> 
}

export type ApiGetOrderBySaleIdQueryResult = NonNullable<Awaited<ReturnType<typeof apiGetOrderBySaleId>>>
export type ApiGetOrderBySaleIdQueryError = ErrorType<BackendErrorEntity>



export function useApiGetOrderBySaleId<TData = Awaited<ReturnType<typeof apiGetOrderBySaleId>>, TError = ErrorType<BackendErrorEntity>>(
 params?: MaybeRef<ApiGetOrderBySaleIdParams>, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof apiGetOrderBySaleId>>, TError, TData>, request?: SecondParameter<typeof fetchApiInstance>}

  ): UseQueryReturnType<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getApiGetOrderBySaleIdQueryOptions(params,options)

  const query = useQuery(queryOptions) as UseQueryReturnType<TData, TError> & { queryKey: QueryKey };

  query.queryKey = unref(queryOptions).queryKey as QueryKey;

  return query;
}



